import { API_ROUTES } from '@/constants/api-routes';
import { API_URL_V3 } from '@/constants/constants';
import { QUERY_KEYS } from '@/constants/query-keys';
import { generateAuthHeaders } from '@/utils/generate-auth-headers';
import axios from 'axios';
import { UseMutationOptions, useMutation } from 'react-query';

export interface StripeConfiguration {
  statusColumnId: string;
  statusColumnLabel: string;
  isPaymentReminderEnabled: boolean;
  remindAfter: number;
  transactionIdColumnId: string;
}

interface UpdateStripeConfigParams {
  envelopeId: string;
  options?: UseMutationOptions<StripeConfiguration, Error, StripeConfiguration>;
}

export const useUpdateStripeConfig = ({
  envelopeId,
  options,
}: UpdateStripeConfigParams) => {
  const updateStripeConfig = async (
    stripeConfiguration: StripeConfiguration,
  ) => {
    try {
      const { data } = await axios<StripeConfiguration>({
        baseURL: API_URL_V3,
        url: API_ROUTES.UPDATE_STRIPE_CONFIGURATION.replace(
          ':envelopeId',
          envelopeId,
        ),
        method: 'PATCH',
        headers: generateAuthHeaders(),
        data: stripeConfiguration,
      });

      return data;
    } catch (error) {
      throw new Error('Failed to update Stripe configuration');
    }
  };

  return useMutation<StripeConfiguration, Error, StripeConfiguration>(
    [QUERY_KEYS.UPDATE_STRIPE_CONFIGURATION, envelopeId],
    updateStripeConfig,
    options,
  );
};
